import type { Order } from '../../../../../../__models__'

export const getBackerName = ({ shipping, email }: Order) => {
  if (!shipping.address) {
    return email
  }

  const { firstName, lastName } = shipping.address

  return [firstName, lastName].filter(Boolean).join(' ')
}
